// Brand-detection from a property's name. Each entry lists the parent brand
// and the sub-brand keywords it owns. First match wins.

export const BRANDS = [
  { key: "marriott", label: "Marriott",       patterns: ["marriott", "courtyard", "residence inn", "fairfield", "springhill", "towneplace", "aloft", "element", "autograph", "moxy", "ac hotel", "renaissance", "westin", "w hotels", "w waikiki", "sheraton", "st. regis", "st regis", "le méridien", "le meridien", "ritz-carlton", "ritz carlton", "gaylord", "delta hotels"] },
  { key: "hilton",   label: "Hilton",         patterns: ["hilton", "hampton inn", "hampton by hilton", "homewood suites", "home2 suites", "embassy suites", "doubletree", "waldorf astoria", "conrad", "curio collection", "tapestry collection", "canopy by hilton", "tempo by hilton", "signia", "tru by hilton", "spark by hilton", "motto by hilton"] },
  { key: "hyatt",    label: "Hyatt",          patterns: ["hyatt", "andaz", "grand hyatt", "park hyatt", "hyatt place", "hyatt house", "hyatt regency", "hyatt centric", "thompson", "alila", "miraval", "destination by hyatt", "unbound collection"] },
  { key: "ihg",      label: "IHG",            patterns: ["intercontinental", "kimpton", "crowne plaza", "holiday inn", "staybridge", "candlewood", "hotel indigo", "even hotels", "voco", "regent", "six senses"] },
  { key: "wyndham",  label: "Wyndham",        patterns: ["wyndham", "ramada", "days inn", "super 8", "la quinta", "wingate", "baymont", "microtel", "travelodge", "hawthorn", "howard johnson", "americinn", "trademark collection", "registry collection", "dolce"] },
  { key: "choice",   label: "Choice Hotels",  patterns: ["comfort inn", "comfort suites", "quality inn", "sleep inn", "clarion", "cambria", "ascend hotel", "suburban studios", "mainstay suites", "rodeway inn", "econo lodge", "everhome suites"] },
  { key: "bestwestern", label: "Best Western", patterns: ["best western", "surestay", "sadie hotel", "aiden hotel", "glō"] },
  { key: "fourseasons", label: "Four Seasons", patterns: ["four seasons"] },
  { key: "outrigger", label: "Outrigger",     patterns: ["outrigger", "ohana hotel"] },
  { key: "aston",    label: "Aqua-Aston",     patterns: ["aston ", "aston at", "aqua ", "aqua-aston"] },
  { key: "castle",   label: "Castle Resorts", patterns: ["castle "] },
  { key: "hilton_grand_vacations", label: "Hilton Grand Vacations", patterns: ["hilton grand vacations"] },
  { key: "prince",   label: "Prince / Mauna Kea", patterns: ["prince waikiki", "mauna kea beach hotel", "hapuna"] },
  { key: "halekulani", label: "Halekulani",   patterns: ["halekulani"] }
];

const BRAND_BY_KEY = new Map(BRANDS.map(b => [b.key, b]));

// Precompute a name → brand key for fast repeated lookups
const cache = new Map();
export function brandFor(name) {
  if (!name) return null;
  if (cache.has(name)) return cache.get(name);
  const lower = name.toLowerCase();
  let hit = null;
  for (const b of BRANDS) {
    if (b.patterns.some(pat => lower.includes(pat))) { hit = b.key; break; }
  }
  cache.set(name, hit);
  return hit;
}

export function brandLabel(key) {
  return BRAND_BY_KEY.get(key)?.label || key;
}
